import { Model, View } from '@lernetz/ts-lib';
import { context } from '@lernetz/ts-lib/src/view/Template';
import type { Asset } from '../Asset';

export class CoverImage extends Model {

    public readonly image: Asset;
    public readonly imageSmall: Asset;

    public constructor( dto ) {
        super( { image: null, imageSmall: null, ...dto } );
    }
}

export class CoverImageView extends View<CoverImage> {

    private static nextId: number = 1;
    private id: string;

    public constructor() {
        super( { template: '' } );
    }

    init() {
        // What we want is to set `background-image` with `@media` queries.
        // This can only be done in CSS stylesheets, so we generate one just for this
        // particular element, which we target by giving it a unique `data-id`.

        const id = `cover-image-${CoverImageView.nextId++}`;
        this.node.id = id;

        // Now we generate a stylesheet.

        // The following break points match up with those defined in the Dateneditor's `assets.php`.
        // We use common monitor widths in general. 768px is the breakpoint used across this
        // project to distinguish between mobile and non-mobile views.
        const css = `
        #${id} {
            background-image: url(${this.data.imageSmall ? context.imagePath(this.data.imageSmall, 'original') : context.imagePath(this.data.image, 'medium')});
            background-position: center top;
            background-size: cover;
        }
        @media all and (min-width: 768px) {
            #${id} {
                background-image: url(${context.imagePath(this.data.image, 'medium')});
            }
        }
        @media all and (min-width: 1280px) {
            #${id} {
                background-image: url(${context.imagePath(this.data.image, 'large')});
            }
        }
        @media all and (min-width: 1920px) {
            #${id} {
                background-image: url(${context.imagePath(this.data.image, 'original')});
            }
        }`;

        // Finally, we add the stylesheet to the document:

        // TODO:
        const style = document.createElement('style');
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
    }
}
